import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { UploadFile } from 'types'
import { convertBytesNumberToString } from 'utils/transforms/number'

const checkMaxUploadedFiles = (files: UploadFile[], maxFiles?: number) => {
  if (!maxFiles) return true
  return maxFiles >= Number(files.length)
}

const checkMinUploadedFiles = (files: UploadFile[], minFiles?: number) => {
  if (!minFiles) return true

  return minFiles <= Number(files.length)
}

const checkFileMinSize = (file: UploadFile, minSize?: number) => {
  if (!minSize) return true
  return minSize <= Number(file.size)
}

const checkFileMaxSize = (file: UploadFile, maxSize?: number) => {
  if (!maxSize) return true
  return maxSize >= Number(file.size)
}

const checkFileExtension = (file: UploadFile, extensions?: string[]) => {
  if (!extensions) return true
  const currentAcceptFiles = (extensions || []).map((file) => file.toLowerCase())

  if (currentAcceptFiles.length === 0) return true
  return currentAcceptFiles.includes(file.extension as string)
}

function isVariableAMatrix(files: Array<string[]> | UploadFile[]): files is Array<string[]> {
  return files.length > 0 && Array.isArray(files[0]) && typeof files[0][0] === 'string'
}

function dynamicMultipleFileUploadValidators(
  files: Array<string[]> | UploadFile[],
  question: CustomFormQuestion
): string {
  let errorMessage = ''

  if (isVariableAMatrix(files)) {
    return ''
  }

  if (question.validation) {
    const { extensions, min, max, min_file, max_file } = question.validation

    if (files.length > 0 && !checkMaxUploadedFiles(files, max_file)) {
      errorMessage = `Máximo de arquivos simultâneos excedidos (${files.length})`
    }
    if (files.length > 0 && !checkMinUploadedFiles(files, min_file)) {
      errorMessage = `Mínimo de arquivos simultâneos não alcançado (${files.length})`
    }

    files.forEach((file) => {
      if (!checkFileExtension(file, extensions)) {
        errorMessage = `Extensão não permitida (${file.extension?.toUpperCase()})`
      }
      if (!checkFileMaxSize(file, max)) {
        errorMessage = `Arquivo maior que o permitido (tamanho do seu arquivo: ${convertBytesNumberToString(
          file.size!
        )})`
      }
      if (!checkFileMinSize(file, min)) {
        console.log('checkFileMinSize(file, min)', checkFileMinSize(file, min))
        errorMessage = `Arquivo menor que o permitido (tamanho do seu arquivo: ${convertBytesNumberToString(
          file.size!
        )})`
      }
    })
  }

  return errorMessage
}

type ValidateSingleFileUploadOnCustomFormParams = {
  files: Array<string[]> | UploadFile[]
  question: CustomFormQuestion
}

export default function validateMultipleFileUploadOnCustomForm({
  files,
  question,
}: ValidateSingleFileUploadOnCustomFormParams) {
  let error = ''
  if (files.length === 0 && question.is_required) {
    error = 'Este campo é obrigatório'
  }
  const errorMessage = dynamicMultipleFileUploadValidators(files, question)
  if (errorMessage !== '') {
    error = errorMessage
  }
  return error
}
